import ClaimsContainer from './containers/ClaimsContainer.jsx'

// Sync route definition
export default {
  path      : '/claims',
  component : ClaimsContainer
}



// WEBPACK FOOTER //
// ./src/routes/Claims/index.jsx